"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../../index");

var _semanticUiReact = require("semantic-ui-react");

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setSelected", function (row) {
      // If the incoming row exists in the selectedValues already remove it
      // otherwise add it.
      // First identify a match in the selectedValues
      var matchedArr = Object.entries(_this.state.selectedValues).filter(function (value, i) {
        return value[1].categoryId === row.categoryId;
      }); // if there are results in the matchedArr

      matchedArr.length > 0 ? // remove the row from selectedValues
      _this.setState({
        selectedValues: _this.state.selectedValues.filter(function (value) {
          return value.categoryId !== row.categoryId;
        })
      }) : // add the row to selectedValues
      _this.setState({
        selectedValues: [].concat(_this.state.selectedValues, [row])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSelect", function () {
      _this.setState(_extends({}, _this.state, {
        open: !_this.state.open
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState(_extends({}, _this.state, {
        open: false
      }));
    });

    _this.state = {
      open: false,
      selectedValues: []
    };
    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      selectedValues: this.props.defaultThemes
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultThemes !== prevProps.defaultThemes) {
      this.setState({
        selectedValues: this.props.defaultThemes
      });
    }

    if (this.state.selectedValues !== prevState.selectedValues) {
      this.props.onUpdate(this.state.selectedValues);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        loading = _this$props.loading,
        values = _this$props.values;
    var _this$state = this.state,
        open = _this$state.open,
        selectedValues = _this$state.selectedValues;
    var selectMessage = '';

    if (selectedValues.length === 1) {
      selectMessage = "Showing " + selectedValues[0].categoryLabel;
    } else if (values.length === selectedValues.length || selectedValues.length === 0) {
      selectMessage = 'Showing all themes';
    } else {
      selectMessage = "Showing " + selectedValues.length + " themes";
    }

    if (loading && !values) {
      return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "select"
    }, /*#__PURE__*/React.createElement("button", {
      className: "select__header " + (open ? 'open' : ''),
      onClick: this.toggleSelect,
      "data-testid": "select-header"
    }, selectMessage, /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
      name: "dropdown"
    })), /*#__PURE__*/React.createElement("ul", {
      className: "select__list " + (open ? 'open' : '')
    }, values && values.map(function (row, key) {
      var selected = _this2.state.selectedValues.filter(function (value) {
        return value.categoryId === row.categoryId;
      }).length > 0;
      return /*#__PURE__*/React.createElement("li", {
        className: "select__list-item",
        key: key
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
        className: "select__button " + (selected ? 'selected' : ''),
        checked: selected,
        onClick: function onClick() {
          return _this2.setSelected(row);
        },
        label: row.categoryLabel
      }));
    })));
  };

  return Select;
}(React.Component);

var _default = (0, _reactOnclickoutside["default"])(Select);

exports["default"] = _default;